export default __webpack_public_path__ + "static/media/success.6ff0d6bd.gif";